










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'tags',
})
export default class Tags extends Vue {
  @Prop()
  tags!:Array<String>;

  @Prop()
  filter!:boolean;

  get filteredTags():Array<String> {
    if (!this.filter || !this.tags) {
      return this.tags;
    }
    let filteredTags = this.tags.filter(tag => tag && tag.indexOf('cheapeats') === -1);
    if (filteredTags.length < this.tags.length) {
      filteredTags.push('cheapeats');
    }
    return filteredTags;
  }
}
